// importing external modules
import { Message } from './message.model';
// class declaration
export class BapiReturnList {
    // composition of the model
    public message_list: Message[];
}



// WEBPACK FOOTER //
// ./src/app/model/common/bapi_return_list.model.ts